import { useMemo } from "react";
import { Spinner } from "../../components/loaders";
import NewBusinessRegister from "../../features/newbusinessregister";
import { FilterProvider, NewBusinessRegisterDefaultFilters } from "../../hooks/FilterContext";
import { useFetchDefaultServiceLevelAgreementsQuery } from "../../services/clientserviceterms";

const ManagementReportsNewBusinessRegisterPage = () => {
    const { data: slas, isFetching: isFetchingSlas } = useFetchDefaultServiceLevelAgreementsQuery();

    const defaultFilters = useMemo(() => {
        if (!slas)
            return NewBusinessRegisterDefaultFilters;

        return {
            ...NewBusinessRegisterDefaultFilters,
            serviceLevelAgreementIds: slas.map(x => x.agreementId)
        }
    }, [slas]);

    if (isFetchingSlas)
        return <Spinner className="m-auto" animation="border" />;

    return <FilterProvider defaultFilters={defaultFilters} filterStore={"management.reports.business-register"}>
        <NewBusinessRegister />
    </FilterProvider>
}

export default ManagementReportsNewBusinessRegisterPage;